import { URL_CDN } from "src/constants/path";

export const mapDeviceToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const showHomePageOption = [
  {
    id: "show",
    name: "Show",
  },
  {
    id: "hide",
    name: "Hide",
  },
];

export const deviceColumns = [
  {
    key: "iconImage",
    label: "Icon Image",
    align: "center",
    render: (item) => (
      <img
        style={{ width: "50px", height: "50px" }}
        src={`${URL_CDN}/${item?.icon?.pathname}`}
        alt={item.code}
      />
    ),
  },
  {
    key: "categoryName",
    label: "Category",
    align: "center",
    render: (item) => <p>{item?.category?.name}</p>,
  },
  {
    key: "avatar",
    label: "Avatar",
    align: "center",
    render: (item) => (
      <img
        style={{ width: "50px", height: "50px" }}
        src={`${URL_CDN}/${item?.avatar}`}
        alt={item.code}
      />
    ),
  },
  {
    key: "iotPartner",
    label: "Iot Partner",
    align: "center",
    render: (item) => (
      <p>{item.iotPartner ? item.iotPartner.partnerName : ""}</p>
    ),
  },

  { key: "name", label: "Name", align: "center" },
];
